import type { FamilyMember } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import {
    AddRow,
    MissingRow,
    PersonRow,
    ProfileParagraph,
    ProfileSection,
} from "../profilePrimitives";
import { listMissingLabels } from "../profileUtils";

export function FamilySection({
    familyMustKnow,
    family,
    setOverlay,
}: {
    familyMustKnow?: string;
    family: FamilyMember[];
    setOverlay: OpenProfileOverlay;
}) {
    return (
        <ProfileSection
            title="Family"
            editable
            onEdit={() => setOverlay({ type: "edit", section: "family" })}
        >
            {familyMustKnow && <ProfileParagraph>{familyMustKnow}</ProfileParagraph>}
            <MissingRow
                labels={listMissingLabels([
                    { label: "Must know", present: !!familyMustKnow },
                    {
                        label: "Family members",
                        present: family.length > 0,
                    },
                ])}
            />
            {family.map((member) => (
                <PersonRow
                    key={member.id}
                    member={member}
                    href={
                        member.kind === "linked"
                            ? `/member/${member.linkedMemberId}`
                            : undefined
                    }
                    onView={
                        member.kind === "limited"
                            ? () => setOverlay({ type: "family-view", member })
                            : undefined
                    }
                    onEdit={() =>
                        setOverlay({
                            type: "family-form",
                            kind: member.kind,
                            member,
                        })
                    }
                    onRemove={() => setOverlay({ type: "family-delete", member })}
                />
            ))}
            <AddRow
                label="Add"
                menu={[
                    {
                        label: "Limited profile",
                        onClick: () =>
                            setOverlay({
                                type: "family-form",
                                kind: "limited",
                            }),
                    },
                    {
                        label: "Link an existing member",
                        onClick: () =>
                            setOverlay({
                                type: "family-form",
                                kind: "linked",
                            }),
                    },
                ]}
            />
        </ProfileSection>
    );
}
